module.exports = __webpack_public_path__ + "569f4a54a6daaf3fd1fa02f185d258a1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-23.png
// module id = 1740
// module chunks = 0